<template>
  <b-card class="mt-4 mb-4">
    <validation-observer ref="mainForm" v-slot="{ invalid }">
    <b-container>
      <b-row>
        <b-col>
          <h5 class="c-red">{{$tc('warnings.motivationRequired', 1)}}</h5>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6" col-sm="12" col-md="12" col-lg="6" col-xl="6">
          <b-form-group label-for="input-motivation" :label="`${$tc('message.motivation', 1)}`">
            <model-list-select id="input-motivation"
                               option-text="text"
                               option-value="id"
                               :placeholder="motivationItems && motivationItems.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                               v-model="motivation.main"
                               :list="motivationItems">
            </model-list-select>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <validation-provider :name="$tc('message.note', 1).toLowerCase()"
                               :rules="{ max: 250}"
                               v-slot="{ changed, valid, errors }">
          <b-form-group :label="`${$tc('message.note', 2)}`"
                        label-for="motivation-notes">
            <b-form-textarea id="motivation-notes"
                             v-model="motivation.notes"
                             rows="2"
                             type="text"
                             :state="changed && !valid ? false : null">
            </b-form-textarea>
            <div v-if="changed && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
          </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <b-row align-h="center">
        <b-col cols="auto">
          <b-button class="b-c-green"
                    @click="saveMotivation(motivation)"
                    :disabled="!motivation || !motivation.main || invalid">
            {{$tc('message.save', 1)}} {{$tc('message.motivation', 1).toLowerCase()}}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    </validation-observer>
  </b-card>
</template>

<script>
import Vue from 'vue'
import { first } from 'lodash'
import motivations from '@/plugins/motivations'

export default {
  name: 'AccessMotivation',
  created () {
    this.getMotivationObj()
  },
  data () {
    return {
      first,
      // motivation data
      motivation: {
        main: null,
        notes: null
      },
      motivationItems: []
    }
  },
  methods: {
    saveMotivation (tryNumber) {
      const logObj = Vue.getLogObj(this, 'post', '/application_logs')
      logObj.data.mainMotivation = this.motivation.main
      logObj.data.mainNotes = this.motivation.notes
      logObj.data.success = true
      logObj.mode = 'get'

      Vue.putOrPost(this, false, '/application_logs', logObj, false).then(() => {
        this.$emit('motivationSent', logObj)
      }).catch(() => {
        if (tryNumber < 9) this.saveMotivation(tryNumber ? tryNumber + 1 : 1)
        else this.$emit('motivationSent', logObj)
      })
    },
    getMotivationObj () {
      this.motivationItems = []
      motivations.forEach(motivation => {
        this.motivationItems.push({
          id: motivation.id,
          text: this.$tc(motivation.text, 1)
        })
      })
    },
    reset () {
      this.motivation = {
        main: null,
        notes: null
      }
      this.getMotivationObj()
    }
  }
}
</script>
